// bridge: the device voice asks the help-audio module for a stored recording first
let player = null;
export const setStoredPlayer = (f) => { player = f; };
export const playStored = (text, lang) => !!player?.(text, lang);
